<template>
  <div class="_width:100%">
    <i-card v-if="form" color="teal" size="sm" am-table-pane>
      <div
        class="_display:flex _justify-content:space-between _align-items:center _padding-right:1 _padding-left:1"
      >
        {{ isCopy ? 'COPY STEP' : isNew ? 'ADD STEP' : 'EDIT STEP' }} {{ categoryName }}
        <div>
          <i-button
            v-if="$route.query.db && $route.query.table && $route.query.subtable"
            size="sm"
            @click="$router.push({
              name: 'InstructionsView',
              params: {
                db: $route.query.db,
                table: $route.query.table,
                subtable: $route.query.subtable
              },
              query: {
                page: $route.query.page,
                search: $route.query.search,
                filter: $route.query.filter,
                attrs: $route.query.attrs
              }
            })"
          >
            Back
          </i-button>
          <i-button
            v-else
            size="sm"
            @click="$router.push({
              name: 'InstructionsView',
              params: {
                db: category.root_code || 'womenswear',
                table: category.parent_code || 'wm_dresses_no_waist',
                subtable: category.id && category.code ?
                  `${category.id}-${category.code}` :
                  '3-wm_variations_no_waist'
              }
            })"
          >
            Back
          </i-button>
          <i-button
            size="sm"
            color="success"
            class="_margin-left:1/4"
            @click="saveInstruction"
            :disabled="isParamError || algError || excluded_algsError"
          >
            Save
            <i-icon name="ink-check" class="_margin-left:1/2" />
          </i-button>
        </div>
      </div>
    </i-card>
    <i-alert color="danger" v-if="isCopyError" size="sm" dismissible v-model="isCopyError">
    <template #icon>
      <i-icon name="ink-danger" />
    </template>
      <p>No data changed</p>
    </i-alert>
    <div v-if="form" style="height:100%; display:flex">
      <div
        am-insruction-create
        class="_padding-bottom:3 _padding-top:1 _padding-left:1 _padding-right:1"
      >
        <i-card class="_margin-bottom:1">
          <p class="_font-size:md _text-transform:uppercase">Step name</p>
          <i-input v-model="form.step_name" @change="changeFields('step_name')" />
        </i-card>
        <i-card class="_margin-bottom:1">
          <p class="_font-size:md _text-transform:uppercase">Step number</p>
          <i-input v-model.number="form.step" type="number" @change="changeFields('step')" />
        </i-card>
        <i-card class="_margin-bottom:1">
          <p class="_font-size:md _text-transform:uppercase">Content</p>
          <content-input v-model="form.content" @change="changeFields('content')" />
        </i-card>
        <i-card class="_margin-bottom:1" v-if="form.newImages">
          <p class="_font-size:md _text-transform:uppercase">Images</p>
          <draggable v-model="form.newImages" item-key="index" class="drag">
            <template #item="{element, index}" >
              <i-card
                am-img-block
                class="_margin-bottom:1/2 _width:30% _margin-right:1/2"
              >
                <div
                  class="_position:relative"
                  am-img
                >
                  <img v-if="element.image_urls" :src="element.image_urls" />
                  <div
                    v-else
                    v-html="element.image"
                    am-svg-container
                  />
                  <div am-hover @click="showModal({ svg: element.image, url: element.image_urls })">
                    <svg>
                      <use xlink:href="@/assets/icons.svg#open-modal" />
                    </svg>
                  </div>
                </div>
                <p>{{ element.name ? element.name : element.images_names  }}</p>
                <div class="_display:flex _justify-content:end _align-items:center _margin-top:1/2">
                  <i-button
                    v-if="element.image_urls"
                    @click="downloadImg(element.image_urls, element.images_names)"
                    class="_width:50%"
                  >
                    Download
                    <svg viewBox="0 0 16 16" am-icon="color" class="_margin-left:1/2">
                      <use xlink:href="@/assets/icons.svg#download" x="0" y="0" width="16" height="16" />
                    </svg>
                  </i-button>
                  <a v-else :href="downloadUploadImage(element.image)" :download="element.name">
                    <i-button>
                      Download
                      <svg class="_margin-left:1/2" viewBox="0 0 16 16" am-icon="color">
                        <use xlink:href="@/assets/icons.svg#download" x="0" y="0" width="16" height="16" />
                      </svg>
                    </i-button>
                  </a>
                  <i-button
                    @click="isDeleteImage = true; deleteImageIndex = index"
                    class="_width:50% _margin-left:1/2"
                  >
                    Delete
                  </i-button>
                </div>
              </i-card>
            </template>
          </draggable>
          <i-card
            am-upload-card
          >
            <label am-upload-area>
              <div am-upload-area-text>
                Drag files to this area or  <span>select from your computer</span>
              </div>
              <input
                type="file"
                title="Drag files to this area"
                multiple
                accept=".svg"
                @change="updateFileList"
                am-image-input
              />
            </label>
          </i-card>
        </i-card>
        <i-card class="_margin-bottom:1">
          <p class="_font-size:md _text-transform:uppercase">Compatible Types</p>
          <div>
            <div class="_display:flex _flex-wrap:wrap _align-items:center">
              <i-badge
                color="success"
                v-for="(type, index) in form.element_types"
                :key="index"
                am-tag-badge
                class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
              >
                <p>{{ type }}</p>
                <div class="_display:flex _align-items:center">
                  <svg
                    am-icon
                    @click="() => {
                      form.element_types.splice(index, 1);
                      changeFields('element_types')
                    }"
                    viewBox="0 0 24 24"
                    style="fill: var(----color);"
                  >
                    <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
                  </svg>
                </div>
              </i-badge>
              <svg
                viewBox="0 0 24 24"
                class="_margin-left:1/4"
                am-icon="color"
                :am-loading="isLoad"
                @click="showType()"
              >
                <use v-if="!isLoad" xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24" />
                <use v-else xlink:href="@/assets/icons.svg#preloader" x="0" y="0" width="24" height="24" />
                <rect x="0" y="0" width="24" height="24" fill="transparent"></rect>
              </svg>
            </div>
            <div v-if="isShowTypes && !isLoad" am-add-types>
              <hr>
              <i-input
                v-model="searchType"
                placeholder="search type.."
              />
              <div
                v-if="filterTypes"
                class="_margin-top:1/2 _display:flex _flex-wrap:wrap _align-items:center"
              >
                <i-badge
                  color="primary"
                  v-for="type in filterTypes"
                  :key="type"
                  am-tag-badge="pointer"
                  class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
                  @click="() => {
                    form.element_types.push(type);
                    changeFields('element_types')
                  }"
                >
                  <p>{{ type }}</p>
                </i-badge>
              </div>
              <div v-else class="_margin:1/2">
                No results
              </div>
            </div>
          </div>
        </i-card>
        <i-card class="_margin-bottom:1">
          <p class="_font-size:md _text-transform:uppercase">Algoritm number</p>
          <i-radio-group
            v-model="form.multiple_algs"
            class="_margin-bottom:1 _margin-top:1"
            @change="changeFields('multiple_algs')"
          >
            <i-radio :value="1">
              should match<b class="_margin-right:1/4 _margin-left:1/4">all</b>algorithms
            </i-radio>
            <i-radio :value="0">
              should match<b class="_margin-right:1/4 _margin-left:1/4"> any of </b>algorithms
            </i-radio>
          </i-radio-group>
          <div class="_display:flex _flex-direction:column">
            <div
              v-for="(algoritm, index) in form.algs"
              :key="index"
              class="_display:inline-flex _align-items:center _width:100% _margin-bottom:2"
            >
              <algorithm-input
                :alg="form.algs[index]"
                @update="(n)=> {
                  form.algs[index] = n.data;
                  changeFields('algs')
                }"
                @delete="() => {
                  form.algs.splice(index, 1);
                  changeFields('algs')
                }"
              />
            </div>
            <svg am-icon viewBox="0 0 24 24" class="_margin-top:1/2" @click="() => {
              form.algs.push('');
              changeFields('algs')
            }">
              <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24"></use>
            </svg>
          </div>
        </i-card>
        <i-card class="_margin-bottom:1">
          <p class="_font-size:md _text-transform:uppercase">Excluded algoritm number</p>
          <div class="_display:flex _flex-direction:column">
            <div
              v-for="(algoritm, index) in form.excluded_algs"
              :key="index"
              class="_display:inline-flex _align-items:center _width:100% _margin-bottom:2"
            >
              <algorithm-input
                :alg="form.excluded_algs[index]"
                @update="(n)=> {
                  form.excluded_algs[index] = n.data;
                  changeFields('excluded_algs')
                }"
                @delete="() => {
                  form.excluded_algs.splice(index, 1);
                  changeFields('excluded_algs')
                }"
              />
            </div>
            <svg am-icon viewBox="0 0 24 24" class="_margin-top:1/2" @click="() => {
              form.excluded_algs.push('');
              changeFields('excluded_algs')
            }">
              <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24"></use>
            </svg>
          </div>
        </i-card>
        <i-card class="_margin-bottom:1">
          <p class="_font-size:md _text-transform:uppercase">Conditions</p>
          <div>
            <div
              v-for="(and, index) in form.conditions"
              :key="index"
              class="_display:flex _flex-direction:column"
            >
              <div v-if="index > 0" class="_margin-top:1/2 _margin-bottom:1/2">
                or
              </div>
              <div class="_display:flex _flex-wrap:wrap" am-cond>
                <div
                  v-for="(param, i) in and"
                  :key="i"
                  class="_display:flex _align-items:center _margin-bottom:2 _margin-top:1"
                >
                  <div am-params-inputs class="_display:flex _position:relative">
                    <input-condition
                      v-model="param.key"
                      placeholder="key"
                      @change="(event)=>watchKey(event, index, i)"
                      :error="paramKeyError[i + '-' + index]"
                      :errorMessage="valuesPar.join(', ')"
                    />
                    <p class="_margin-left:1"></p>
                    <input-condition
                      v-model="param.value"
                      @keypress="watchValue"
                      placeholder="value"
                    />
                    <formulaTooltip :number="param.key" :value="param.value" />
                  </div>
                  <svg
                    viewBox="0 0 24 24"
                    am-icon
                    style="fill: var(----color);"
                    class="_margin-left:1/2"
                    @click="delParam(index, i)"
                  >
                    <use xlink:href="@/assets/icons.svg#minus-bg" x="0" y="0" width="24" height="24"></use>
                  </svg>
                  <i-button
                    class="_margin-left:1"
                    v-if="and.length - 1 === i"
                    @click="() => {
                      and.push({ key: '', value: '' });
                      changeFields('cond')
                    }"
                  >
                    AND
                  </i-button>
                  <div v-else class="_margin-left:1 _margin-right:2">and</div>
                  <svg
                    viewBox="0 0 24 24"
                    am-icon
                    style="fill: var(----color);"
                    class="_margin-left:1/2"
                    @click="delCondions(index)"
                    v-if="and.length - 1 === i"
                  >
                    <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
                  </svg>
                </div>
              </div>
              <i-button
                class="_margin-top:1"
                v-if="form.conditions.length - 1 === index"
                @click="() => {
                  form.conditions.push([{ key: '', value: '' }]);
                  changeFields('cond')
                }"
              >
                OR
              </i-button>
            </div>
          </div>
        </i-card>
        <i-card class="_margin-bottom:1">
          <p class="_font-size:md _text-transform:uppercase">Attributes</p>
          <div>
            <div class="_display:flex _flex-wrap:wrap _align-items:center">
              <i-badge
                color="primary"
                v-for="(attr, index) in form.attributes"
                :key="index"
                :am-tag-badge="attr.id % 10"
                class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
              >
                <p>
                  {{
                    (attr.type[0].toUpperCase() +
                    attr.type.slice(1)).replaceAll('_', ' ').replace('type', '') +
                    ' : ' + attr.name
                  }}
                </p>
                <div class="_display:flex _align-items:center">
                  <svg
                    viewBox="0 0 24 24"
                    am-icon
                    style="fill: var(----color);"
                    @click="() => {
                      form.attributes.splice(index, 1);
                      changeFields('attrs')
                    }"
                  >
                    <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
                  </svg>
                </div>
              </i-badge>
              <svg
                v-if="!isShowAttr && !loading"
                viewBox="0 0 24 24"
                am-icon="color"
                class="_margin-left:1/4"
                @click="openAttrs"
              >
                <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24" />
                <rect x="0" y="0" width="24" height="24" fill="transparent"></rect>
              </svg>
            </div>
            <div v-if="isShowAttr" am-add-attr>
              <hr>
              <div am-search-attr class="_display:flex _flex-wrap:wrap _align-items:center">
                <i-select
                  v-if="attributesTypes"
                  v-model="selectedType"
                  :options="getAllTypesAttributes"
                  placeholder="Choose attributes type.."
                  class="_margin-right:1"
                  am-block
                  autocomplete
                  clearable
                  @search="setSearchTypeValue"
                  @update:modelValue="fetchAllAttributes({
                    typeAttr: selectedType ? selectedType.id : null, searchAttr: searchAttr
                  })"
                />
                <div am-block>
                  <i-input
                    v-model="searchValue"
                    placeholder="search attr.."
                  />
                </div>
              </div>
              <hr>
              <div class="_display:flex _justify-content:center">
                <i-loader v-if="loading" color="primary" size="sm" />
              </div>
              <div
                v-if="(selectedType || searchAttr) && !loading && filterAttrs && filterAttrs.length > 0"
                class="_padding-top:1 _padding-bottom:1/2 _display:flex _flex-wrap:wrap _align-items:center"
                am-attr-result
              >
                <i-badge
                  color="primary"
                  v-for="attr in filterAttrs"
                  :key="attr.id"
                  :am-tag-badge="attr.id % 10"
                  class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
                  @click="() => {
                    form.attributes.push(attr);
                    changeFields('attrs')
                  }"
                >
                  <p>
                    {{
                      (attr.type[0].toUpperCase() +
                      attr.type.slice(1)).replaceAll('_', ' ').replace('type', '') +
                      ' : ' + attr.name
                    }}
                  </p>
                </i-badge>
              </div>
              <div
                v-if="(selectedType || searchAttr) && !loading && (!filterAttrs || filterAttrs.length === 0)"
                class="_padding:1/2"
              >
                No results
              </div>
            </div>
          </div>
        </i-card>
        <i-card class="_margin-bottom:1">
          <p class="_font-size:md _text-transform:uppercase">isActive</p>
          <IToggle @update:modelValue="updateStatus" :modelValue="setIsActive(form.status)" />
        </i-card>
        <i-card>
          <div style="margin-bottom:10px;text-transform: uppercase;">Test PF Design</div>
          <content-input v-model="pfLink" placeholder="Put PF link here"></content-input>
          <div style="display:flex">
            <div style="flex:1;display:flex;align-items:center">
              <template v-if="pfLinkResult.ok !== undefined">
                <span v-if="pfLinkResult.ok">Everything looks good!</span>
                <div v-else>
                  <div v-if="pfLinkResult.params.length > 0">
                    Not matched params: {{ pfLinkResult.params.join(', ') }}
                  </div>
                  <div v-if="!pfLinkResult.attrs_matched">Attributes not matched</div>
                  <div v-if="!pfLinkResult.algs_matched">Algorithms not matched</div>
                  <div v-if="!pfLinkResult.types_matched">Compatible types not matched</div>
                </div>
              </template>
            </div>
            <div>
              <button @click="checkLinkClick" class="button -success -sm" style="margin-top:10px">Check</button>
            </div>
          </div>
          <div style="margin-top:5px">
            <div :style="'display:inline;margin-right:5px; ' + getParamStyle(k)" v-for="(v, k) in pfLinkResult.all_params" :key="k">{{ k + ":" + v }}</div>
          </div>
        </i-card>
      </div>
      <div am-activity>
        <instruction-activity />
      </div>
    </div>
    <div
      v-if="errorMessage"
      class="_display:flex _justify-content:center _align-items:center _flex-direction:column _width:100% _height:50%"
    >
      <h3>404 error</h3>
      <p>Instructions for childrenswear and some designs with linings are still in the airtable</p>
    </div>
    <image-modal v-if="instructions.modal.isShow"/>
    <div v-if="isDeleteImage">
      <i-modal v-model="isDeleteImage" am-modal-confirm size="sm">
        <template #header>
          Do you want to delete the picture?
        </template>
        <div
          class="_display:flex _justify-content:space-between"
        >
          <i-button am-button @click="isDeleteImage = false">No</i-button>
          <i-button am-button color="primary" @click="deleteImage()">Yes</i-button>
        </div>
      </i-modal>
    </div>
    <div v-if="isShowWarning">
      <i-modal v-model="isShowWarning" am-modal-confirm size="sm">
        <template #header>
          What to do with the changed data
        </template>
        <div
          class="_display:flex _justify-content:space-between"
        >
          <i-button am-button @click="goLink">Delete</i-button>
          <i-button am-button color="primary" @click="saveInstruction">Save</i-button>
        </div>
      </i-modal>
    </div>
  </div>
</template>

<script>
import algorithmInput from '../components/instructions/algorithmInput.vue'
import contentInput from '../components/instructions/contentInput.vue'
import imageModal from '../components/instructions/imageModal.vue'
import formulaTooltip from '../components/formula/formulaTooltip.vue'
import instructionActivity from '../components/activity/instructionActivity.vue'

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import InputCondition from '../components/instructions/inputCondition.vue'
import draggable from 'vuedraggable'

export default {
  name: 'InstructionCreate',
  components: {
    algorithmInput,
    contentInput,
    imageModal,
    InputCondition,
    draggable,
    formulaTooltip,
    instructionActivity
  },
  data: () => ({
    isDeleteImage: false,
    deleteImageIndex: null,
    isLoad: false,
    errorMessage: false,
    form: null,
    editImageIndex: null,
    isShowTypes: false,
    isShowAttr: false,
    selectedType: null,
    searchAttr: '',
    timer: null,
    paramKeyError: {},
    oldForm: null,
    isCopyError: false,
    isShowWarning: false,
    linkTo: null,
    searchType: '',
    category: null,
    changedFields: [],
    pfLink: '',
    pfLinkResult: {
      ok: undefined,
      params: [],
      attrs: [],
      algs_matched: true,
      types_matched: true,
      attrs_matched: true,
      all_params: {}
    }
  }),
  computed: {
    filterAttrs () {
      if (this.allAttr && this.allAttr.length > 0) {
        return this.allAttr.filter((elem) => !this.form.attributes.find(({ id }) => elem.id === id))
      } else return null
    },
    searchValue: {
      get () {
        return this.searchAttr
      },
      set (value) {
        this.searchAttr = value
        clearTimeout(this.timer)
        this.timer = window.setTimeout(() => {
          this.fetchAllAttributes({
            typeAttr: this.selectedType ? this.selectedType.id : null,
            searchAttr: value
          })
        }, 500)
      }
    },
    ...mapState(['instructions']),
    ...mapState('attributes', ['loading', 'allAttr', 'attributesTypes']),
    ...mapGetters('attributes', ['getAllTypesAttributes']),
    ...mapGetters('formula', ['dropValues']),
    valuesPar () {
      return this.dropValues.slice(1)
    },
    isNew () {
      if (this.$route.params.id === 'new') return true
      return false
    },
    isCopy () {
      if (this.$route.params.id.includes('copy')) return true
      return false
    },
    filterTypes () {
      if (this.instructions.types?.all) {
        return this.instructions.types?.all
          .filter((elem) => !this.form.element_types.includes(elem) && elem.includes(this.searchType.toLowerCase()))
      } return false
    },
    isParamError () {
      let error = false
      if (Object.keys(this.paramKeyError).length > 0) {
        Object.keys(this.paramKeyError).forEach(el => {
          if (this.paramKeyError[el] === true) error = true
        })
      }
      return error
    },
    algError () {
      let error = false
      this.form.algs.forEach(alg => {
        const regex = /^[A-Z]{1,}[0-9]{1,}$/g
        const found = regex.test(alg)
        if (!found) {
          error = true
        }
      })
      return error
    },
    excluded_algsError () {
      let error = false
      this.form.excluded_algs.forEach(alg => {
        const regex = /^[A-Z]{1,}[0-9]{1,}$/g
        const found = regex.test(alg)
        if (!found) {
          error = true
        }
      })
      return error
    },
    categoryName () {
      if (this.oldForm?.category) {
        const sp = this.oldForm.category.code.split('_')
        const codes = {
          wm: 'women',
          mn: 'men',
          bo: 'boys',
          gl: 'girls'
        }
        const genderName = codes[sp[0]] || sp[0]
        return ' (' + genderName[0].toUpperCase() + genderName.substring(1) + ' ' + this.oldForm.category.name + ')'
      }
      return ''
    }
  },
  unmounted () {
    this.$store.state.activity.data = null
  },
  async beforeMount () {
    if (this.isNew) {
      this.oldForm = {
        images_names: [],
        images: [],
        image_urls: [],
        step_name: null,
        algs: [],
        element_types: [],
        content: null,
        step: null,
        cond: [],
        conditions: [
          [{
            value: '',
            key: ''
          }]
        ],
        multiple_algs: 0,
        files: [],
        attributes: [],
        attrs: [],
        newImages: [],
        excluded_algs: []
      }
      this.form = {
        images_names: [],
        images: [],
        image_urls: [],
        step_name: null,
        algs: [],
        element_types: [],
        content: null,
        step: null,
        cond: [],
        conditions: [
          [{
            value: '',
            key: ''
          }]
        ],
        multiple_algs: 0,
        files: [],
        attributes: [],
        attrs: [],
        newImages: [],
        excluded_algs: []
      }
    } else {
      let id = null
      if (this.isCopy) {
        id = this.$route.params.id.split('_')[1]
      } else if (!this.isNew) {
        id = this.$route.params.id
        this.$store.dispatch('activity/getActivity', `instruction_id=${id}`)
      }
      this.oldForm = await this.getInstruction(id)
      if (!this.oldForm) this.errorMessage = true
      else {
        this.form = {}
        for (const key in this.oldForm) {
          if (key === 'conditions') {
            this.form[key] = []
            if (
              this.oldForm.cond.length === 0 ||
              (this.oldForm.cond.length === 1 && Array.isArray(this.oldForm.cond[0]))
            ) {
              this.oldForm.conditions = [[{
                value: '',
                key: ''
              }]]
              this.form.conditions.push(
                [{
                  value: '',
                  key: ''
                }]
              )
            } else {
              this.oldForm.cond.forEach((condition, index) => {
                this.form.conditions.push([])
                for (const key in condition) {
                  const value = condition[key] instanceof Array ? condition[key].join() : condition[key]
                  this.form.conditions[index].push({ key: key, value: value })
                }
              })
            }
          } else if (Array.isArray(this.oldForm[key])) {
            this.form[key] = this.oldForm[key].slice(0)
          } else if (typeof this.oldForm[key] === 'object' && this.oldForm[key] !== null) {
            this.form[key] = {}
            for (const objectKey in this.oldForm[key]) {
              this.form[key][objectKey] = this.oldForm[key][objectKey]
            }
          } else this.form[key] = this.oldForm[key]
        }
        this.oldForm.newImages = []
        this.form.newImages = []
        if (this.oldForm.image_urls.length > 0) {
          this.oldForm.image_urls.forEach((el, index) => {
            const img = {
              image_urls: el,
              images_names: this.oldForm.images_names[index],
              images: this.oldForm.images[index]
            }
            this.oldForm.newImages.push(img)
            this.form.newImages.push(img)
          })
        }
      }
    }
    if (!this.$route.query.db || !this.$route.query.table || !this.$route.query.subtable) {
      this.category = await this.getPartCategory(this.oldForm.category_id)
      this.setCategories({
        db: this.category.root_code,
        table: this.category.parent_code,
        subtable: this.category.id + '-' + this.category.code
      })
    } else {
      this.setCategories({
        db: this.$route.query.db,
        table: this.$route.query.table,
        subtable: this.$route.query.subtable
      })
    }
  },
  beforeRouteLeave (to) {
    if (JSON.stringify(this.form) !== JSON.stringify(this.oldForm)) {
      this.isShowWarning = true
      this.linkTo = to
      return false
    }
  },
  methods: {
    changeFields (field) {
      if (this.changedFields.length) {
        const hazField = this.changedFields.find(el => el === field)
        if (!hazField) {
          this.changedFields.push(field)
        }
      } else this.changedFields.push(field)
    },
    updateStatus (event) {
      this.form.status = 'INACTIVE'
      if (event) this.form.status = 'ACTIVE'
      this.changeFields('status')
    },
    setIsActive (val) {
      if (val === 'INACTIVE') return false
      if (val === 'ACTIVE') return true
    },
    downloadUploadImage (img) {
      const blob = new Blob([img], {
        type: 'image/svg'
      })
      return window.URL.createObjectURL(blob)
    },
    goLink () {
      this.oldForm = this.form
      this.isShowWarning = false
      this.$router.push(this.linkTo.fullPath)
    },
    deleteImage () {
      this.form.newImages.splice(this.deleteImageIndex, 1)
      this.isDeleteImage = false
      this.changeFields('images')
    },
    downloadImg (url, name) {
      fetch(url + (url.includes('?') ? '&' : '?') + 't=' + +Date.now())
        .then(response => response.blob())
        .then(blob => {
          const blobURL = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = blobURL
          a.style = 'display: none'
          if (name && name.length) a.download = name
          document.body.appendChild(a)
          a.click()
        })
    },
    openAttrs () {
      if (!this.attributesTypes || this.attributesTypes.length === 0) this.fetchAttributesTypes()
      this.isShowAttr = true
    },
    delCondions (index) {
      this.form.conditions.splice(index, 1)
      if (this.form.conditions.length === 0) {
        this.form.conditions[0] = [{
          value: '',
          key: ''
        }]
      }
      this.changeFields('cond')
    },
    delParam (index, i) {
      this.form.conditions[index].splice(i, 1)
      if (this.form.conditions[index].length === 0) {
        this.delCondions(index)
      }
      this.changeFields('cond')
    },
    watchKey (event, index, i) {
      const data = event.target.value.toLowerCase()
      const regex = new RegExp(`^[0-9]{1,}$|^${this.valuesPar.join('$|^')}$`, 'g')
      const found = regex.test(data)
      if (!found) {
        this.paramKeyError[i + '-' + index] = true
      } else {
        this.paramKeyError[i + '-' + index] = false
      }
      this.changeFields('cond')
    },
    watchValue (event) {
      const regex = /^[0-9 ,]+$/
      const key = String.fromCharCode(!event.charCode ? event.which : event.charCode)
      if (!regex.test(key)) {
        event.preventDefault()
        return false
      }
      this.changeFields('cond')
    },
    ...mapActions('partCategories', ['getPartCategory', 'setCategories']),
    ...mapActions('instructions', [
      'getInstruction',
      'getInstructions',
      'getTypes',
      'createInstruction',
      'updateInstruction',
      'createImages',
      'checkLink'
    ]),
    ...mapActions('attributes', ['fetchAllAttributes', 'fetchAttributesTypes']),
    ...mapMutations('instructions', ['showModal']),
    ...mapMutations('attributes', ['setSearchTypeValue']),
    ...mapMutations('notifications', ['addNotification']),
    async updateFileList (event) {
      const files = event.target.files
      if (files.length > 0) {
        Array.prototype.forEach.call(files, file => {
          file.text().then(svgText => {
            this.form.newImages.push({
              image: svgText,
              mime: file.type,
              image_base64: window.btoa(unescape(encodeURIComponent(svgText))),
              name: file.name
            })
          })
        })
        this.changeFields('images')
      }
      this.editImageIndex = null
    },
    async showType () {
      this.isLoad = true
      if (!this.instructions.types.all) await this.getTypes()
      this.isLoad = false
      this.isShowTypes = true
    },
    async saveInstruction () {
      if (this.isCopy) {
        if (JSON.stringify(this.form) === JSON.stringify(this.oldForm)) {
          this.isCopyError = true
          return
        } else this.isCopyError = false
      }
      if (this.isParamError || this.algError || this.excluded_algsError) return
      this.form.cond = []
      this.form.conditions.forEach(cond => {
        const obj = {}
        cond.forEach(el => {
          if (el.key && el.value) {
            if (!obj[el.key]) obj[el.key] = []
            if (el.value.includes(',')) {
              el.value.split(',').forEach(v => {
                if (v.trim()) {
                  if (!obj[el.key].includes(Number(v.trim()))) obj[el.key].push(Number(v.trim()))
                }
              })
            } else {
              if (!obj[el.key].includes(Number(el.value.trim()))) obj[el.key].push(Number(el.value.trim()))
            }
          }
        })
        if (Object.keys(obj).length) this.form.cond.push(obj)
      })
      if (this.form.cond.length === 0) {
        this.addNotification({
          notification: {
            type: 'danger',
            message: 'Conditions is required'
          }
        })
        return
      }
      this.form.attrs = {}
      if (this.form.attributes.length > 0) {
        this.form.attributes.forEach(el => {
          if (!this.form.attrs[el.type]) this.form.attrs[el.type] = []
          this.form.attrs[el.type].push(el.id)
        })
      }
      this.form.images_names = []
      this.form.image_urls = []
      this.form.images = []
      this.save()
    },
    async save () {
      if (this.form.newImages.length > 0) {
        for (const el of this.form.newImages) {
          if (el.image) {
            const upload = await this.createImages(el)
            if (upload) {
              this.form.images_names.push(el.name)
              this.form.images.push(upload.name)
              this.form.image_urls.push(upload.url)
            }
          } else {
            this.form.images_names.push(el.images_names)
            this.form.images.push(el.images)
            this.form.image_urls.push(el.image_urls)
          }
        }
      }
      let created = null

      const changedData = {}
      if (this.isCopy) {
        const fieldsArray = ['content', 'algs', 'cond', 'element_types', 'step', 'image_urls', 'images_names', 'images', 'status', 'excluded_algs']
        fieldsArray.forEach(el => {
          changedData[el] = this.form[el]
          return el
        })
      }
      this.changedFields.forEach(el => {
        if (el === 'images') {
          changedData.images_names = this.form.images_names
        }
        changedData[el] = this.form[el]
      })
      if (this.isNew || this.isCopy) {
        changedData.category_id = this.$route.query.subtable.split('-')[0]
        created = await this.createInstruction({ value: changedData })
      } else {
        created = await this.updateInstruction({ value: changedData, id: this.form.id })
      }
      if (created && this.pfLink === '') {
        this.oldForm = this.form
        if (this.linkTo) this.goLink()
        else if (this.$route.query.db && this.$route.query.table && this.$route.query.subtable) {
          this.$router.push({
            name: 'InstructionsView',
            params: {
              db: this.$route.query.db,
              table: this.$route.query.table,
              subtable: this.$route.query.subtable
            },
            query: {
              page: this.$route.query.page,
              search: this.$route.query.search,
              filter: this.$route.query.filter,
              attrs: this.$route.query.attrs
            }
          })
        } else {
          this.$router.push({
            name: 'InstructionsView',
            params: {
              db: this.category.root_code || 'womenswear',
              table: this.category.parent_code || 'wm_dresses_no_waist',
              subtable: this.category.id && this.category.code
                ? `${this.category.id}-${this.category.code}`
                : '3-wm_variations_no_waist'
            }
          })
        }
      }
    },
    async checkLinkClick () {
      const resp = await this.checkLink({ link: this.pfLink, id: this.form.id })
      const data = await resp.json()
      data.ok = false
      if (data.params.length === 0 && data.algs_matched &&
         data.types_matched && data.attrs.length === 0) {
        data.ok = true
      }
      this.pfLinkResult = data
    },
    getParamStyle (num) {
      console.log(this.form.cond[0])
      const regex = /^[1-9]\d*$/
      if (regex.test(num)) {
        num = parseInt(num)
      }
      if (this.pfLinkResult.params.includes(num)) {
        return 'background-color:red'
      } else {
        for (const c of this.form.cond) {
          if (c[num] !== undefined) {
            return 'background-color:green'
          }
        }
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
[am-modal-confirm] [am-button] {
  width: calc(50% - 0.5rem) !important;
}
[am-activity] {
  width: 30%;
  overflow-y: scroll;
  min-width: 310px;
}
[am-insruction-create] {
  width: 70%;
  [am-params-inputs] {
    position: relative;
    &:hover {
      [am-toltip] {
        top: 45px;
        display: block;
      }
    }
  }
  .toggle .toggle-label::before {
    border-color: var(--color--dark-45);
  }
  .drag {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }
  ----font-size: 0.85rem;
  ----line-height: 1.2;
  ----spacing: 0.25rem;
  ----padding: #{var(----spacing)};
  font-size: var(----font-size);
  overflow: auto;
  height: 100%;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type=number] {
    -moz-appearance: textfield;
  }
  .form.-dark .radio, .form-group.-dark .radio, .radio.-dark {
    ----border-color: var(--color--gray-70);
  }
  [am-upload-card] > .card-body {
    padding: 0 !important;
  }
  [am-input-image] {
    opacity: 0;
    position: absolute;
  }
  [am-img-block] {
    min-width: 19rem;
    max-width: 30%;
  }
  [am-img] {
    [am-svg-container], img {
      max-width: 100%;
    }
    [am-hover] {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.6);
      svg {
        margin: 10px;
      }
    }
    &:hover [am-hover] {
      display: block;
      cursor: pointer;
    }
  }
  [am-upload-area] {
    position: relative;
    width: 100%;

    [am-upload-area-text] {
      text-align: center;
      padding: 3rem;

      span { text-decoration: underline; }
    }

    input {
      position: absolute;
      z-index: 5;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0;
    }
  }
  [am-search-attr] {
    [am-block] {
      width: calc(50% - 2rem);
    }
  }
  [am-cond] {
    [am-icon] {
    visibility: hidden;
  }}
  [am-cond]:hover [am-icon] {
    visibility: visible;
  }
  [am-attr-result] {
    max-height: 350px;
    overflow: auto;
  }
}
</style>
